import { render, staticRenderFns } from "./fieldBlocksModal.vue?vue&type=template&id=1be10f71&scoped=true"
import script from "./fieldBlocksModal.vue?vue&type=script&lang=js"
export * from "./fieldBlocksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be10f71",
  null
  
)

export default component.exports